import React, { useEffect, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import ReactDatatable from "@ashvin27/react-datatable";
import { Images } from "../Components/Images";
import InnerFooter from "../Components/InnerFooter";
import { getSchedules, editSchedules } from "../actions/markets";
import { getAccount } from "../Hooks/useAccount";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";

const ScheduleHistory = () => {
  const [schedules, setSchedules] = useState();
  const [pageNumer, setPageNumer] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  useEffect(() => {
    getAllSchedules();
  }, []);

  const getAllSchedules = async () => {
    try {
      let reqData = {
        page: pageNumer,
        limit: limit,
        address: getAccount(),
      };

      let { status, message, result, count } = await getSchedules(reqData);
      if (status == "success") {
        setSchedules(result);
        setCount(count);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePagination = async (index) => {
    console.log(index.filter_value, "index.filter_value");
    let reqData = {
      page: index.page_number,
      limit: index.page_size,
      search: index.filter_value,
      address: getAccount(),
    };
    setPageNumer(index.page_number);
    setLimit(index.page_size);
    const { status, message, result, count } = await getSchedules(reqData);
    setSchedules(result);
    setCount(count);
    // setInterval(loadinterval);
  };

  const changeStatus = async (data) => {
    console.log("datadata", data);
    try {
      let { status, message, result } = await editSchedules(data);
      if (status == "success") {
        getAllSchedules();
      }
    } catch (err) { }
  };

  const state = {
    records: [
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">1</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
      {
        sno: <p className="exchange_table_values m-0 text-center">2</p>,
        transactionHash: (
          <p className="exchange_table_values m-0 text-center">#123</p>
        ),
        borrowAmount: (
          <p className="exchange_table_values m-0 text-center">10</p>
        ),
        pairs: <p className="exchange_table_values m-0 text-center">BTC-ETH</p>,
        profitAmount: (
          <p className="exchange_table_values m-0 text-center">5</p>
        ),
        profitPercentage: (
          <p className="exchange_table_values m-0 text-center">2%</p>
        ),
        profitStatus: (
          <p className="exchange_table_values m-0 text-center">Active</p>
        ),
        transactionStatus: (
          <p className="exchange_table_values m-0 text-center">Completed</p>
        ),
      },
    ],
  };

  const columns = [
    {
      key: "user",
      text: "Address",
      className: "exchange_table_values m-0 text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "symbol",
      text: "Symbol",
      className: "exchange_table_values m-0 text-center",
      align: "center",
      sortable: false,
    },

    {
      key: "difference",
      text: "Difference",
      className: "exchange_table_values m-0 text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "gains",
      text: "Profit Amount",
      className: "exchange_table_values m-0 text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "status",
      text: "Status",
      className: "exchange_table_values m-0 text-center",
      align: "center",
      sortable: false,
    },

    {
      key: "action",
      text: "Action",
      className: "activity",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <>
            <div className="d-flex justify-content-center align-items-center">
              <Dropdown
                className={`cmnStatus__changer ${record.status.toLowerCase() == "cancelled" &&
                  "cmnStatus__cancelChanger"
                  }`}
              >
                <Dropdown.Toggle id="dropdown-basic">
                  {record.status}
                </Dropdown.Toggle>

                {record.status == "Pending" ? (
                  <Dropdown.Menu className="cmnStatus__changerMenu">
                    <Dropdown.Item
                      onClick={() => {
                        changeStatus({
                          _id: record._id,
                          status: false,
                        });
                      }}
                    >
                      Cancelled
                    </Dropdown.Item>
                  </Dropdown.Menu>
                ) : (
                  ""
                )}
              </Dropdown>
            </div>
          </>
        );
      },
    },
  ];
  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",

    language: {
      length_menu: "Show _MENU_ result per page",
      no_data_text: "No Data found",
      loading_text: "No Data Found",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: true,
    show_pagination: true,
    show_info: false,
  };

  const extraButtons = [
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ];

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <div className="common_bgVideo history_page">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />

        <img
          src={Images.planlftOvly}
          className="opportunity__lftBlur img-fluid"
        />
        <img
          src={Images.planrytOvly}
          className="opportunity__rightBlur img-fluid"
        /> */}
        <Header />
        <Container
          fluid
          className="p-0 schedule_history custom_container"
        >
          {/* <img
          src={Images.radiantBlur}
          className="home__dashboardLeftBlur img-fluid"
          alt=""
        />
        <img
          src={Images.radiantBlur}
          className="home__dashboardRightBlur img-fluid"
          alt=""
        /> */}
          {/* <LandingHeader /> */}

          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder pb-3 pb-lg-4">
              <h4 className="m-0 hebrew_bold opportunity__title">
                Schedule History
              </h4>
              <p className="plans__titleHint m-0 hebrew_font position-relative mt-2">
                View a complete log of all past arbitrage scans and execution attempts. Stay informed. Stay in
                control              </p>
              {/* <input
              type="text"
              className="transacHistory__input position-relative hebrew_font w-100 rounded-1 mt-2"
              placeholder="Search with TXN Hash"
            /> */}
              <div className="dashboard__blueBox rounded-2 mt-5">
                <div className="transacHistory__tableHolder">
                  <ReactDatatable
                    config={config}
                    records={schedules}
                    columns={columns}
                    dynamic={true}
                    total_record={count}
                    onChange={(e) => {
                      handlePagination(e);
                    }}
                    filterRecords={(e) => {
                      console.log(e, "filterRecords");
                    }}
                    filterData={(e) => {
                      console.log(e, "filterData");
                    }}
                    loading={([null, undefined].includes(schedules) || []) ? true : false}
                  />
                </div>
              </div>
            </div>
          </Container>
          {/* <InnerFooter /> */}
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default ScheduleHistory;
